import { useCallback, useState } from "react";

export function useReRender(): () => void {
  const [, update] = useState(0);

  const reRender = useCallback(() => {
    update((prev) => prev + 1);
  }, []);

  return reRender;
}
